import { fetchCanonicalChannelAccounts, fetchCanonicalConversationViews, fetchCanonicalConversations } from "./canonicalMessagingApi";

async function* searchPages(search, audience, knownAccounts) {
  const accounts = knownAccounts?.length ? knownAccounts : await fetchCanonicalChannelAccounts();
  for (const account of accounts.filter(item => item.audience === audience || item.audience === "mixed")) {
    const views = await fetchCanonicalConversationViews(account.id);
    const view = views.items.some(item => item.key === "all") ? "all" : views.default_view;
    let cursor;
    const seen = new Set();
    do {
      const page = await fetchCanonicalConversations({ channel_account_id: account.id, view, search, limit: 100, ...(cursor ? { cursor } : {}) });
      yield page.items;
      cursor = page.page.has_more ? page.page.next_cursor : null;
      if (cursor && seen.has(cursor)) break;
      seen.add(cursor);
    } while (cursor);
  }
}

export async function searchCanonicalConversations(search, audience = "customer", knownAccounts = null) {
  if (!String(search || "").trim()) return [];
  const rows = new Map();
  for await (const items of searchPages(search.trim(), audience, knownAccounts)) {
    items.forEach(item => rows.set(item.id, item));
  }
  return [...rows.values()];
}

export async function findCanonicalConversationByPhone(phone, audience = "customer", knownAccounts = null) {
  const normalized = String(phone || "").replace(/\D/g, "");
  if (!normalized) return null;
  for await (const items of searchPages(normalized, audience, knownAccounts)) {
    const hit = items.find(item => String(item.participant?.identities?.phone || "").replace(/\D/g, "") === normalized);
    if (hit) return hit;
  }
  return null;
}
